import { Select, SelectProps } from 'antd';
import React, { memo } from 'react';

import { L } from '@lib';

const { Option } = Select;

export const DriveTypeSelect: React.FC<SelectProps> = memo((props) => (
  <Select
    allowClear
    placeholder={L('Select drive type')}
    style={{ width: '100%' }}
    {...props}
  >
    <Option value="Front Wheel Drive">{L('Front Wheel Drive')}</Option>
    <Option value="Rear Wheel Drive">{L('Rear Wheel Drive')}</Option>
    <Option value="All Wheel Drive">{L('All Wheel Drive')}</Option>
    <Option value="Four Wheel Drive">{L('Four Wheel Drive')}</Option>
  </Select>
));
